import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { ReportsDownloadBillingList } from "../../components/reports/ReportsDownloadBillingList";

// To Do: Add BreadCrum
// Add Translation
export const ReportsDownloadBilling: React.FC = () => {
  const { t } = useTranslation();
  //const breadcrumb = useBreadcrumb("orders");

  

  return (
    <MainContentArea
      header={
        <ContentHeader 
        title={t("main_menu.reports")}
          
        />
        
      }
    >
    
       <ReportsDownloadBillingList /> 
    </MainContentArea>
  );
};
